/* ============================================================
   Biwa Wave — card swatch + same-colour hover
   • Click a swatch  → lock that colour (image swaps, no page jump).
   • Hover a swatch  → preview that colour.
   • Hover the PHOTO → show the 2nd image OF THE SAME colour.
                       If that colour has only one image, do nothing
                       (never jump to a different colour).
   Colour→images are resolved from /products/<handle>.js, assuming the
   gallery is grouped by colour (each variant's featured_image marks the
   start of its colour's run).
   ============================================================ */
(function () {
  'use strict';

  var cache = {};

  function cardOf(el) { return el.closest('.card-wrapper') || el.closest('.card'); }
  function primaryImage(card) { return card ? card.querySelector('.card__media .media img') : null; }
  function strip(s) { return (s || '').split('?')[0]; }
  function fname(s) { return strip(s).split('/').pop(); }   /* match by filename: images use //cdn, variants use https://cdn */
  function withWidth(src, w) { return src ? strip(src) + '?width=' + w : src; }

  function setImage(img, src) {
    if (!img || !src) return;
    if (img.dataset.bwShownSrc === src) return;
    img.dataset.bwShownSrc = src;
    img.style.transition = 'opacity .22s ease';
    var apply = function () {
      img.setAttribute('srcset', '');
      img.setAttribute('sizes', '');
      img.src = src;
      requestAnimationFrame(function () { img.style.opacity = '1'; });
    };
    var fadeThenSwap = function () {
      img.style.opacity = '0';
      setTimeout(apply, 200);   /* fade out, then swap the preloaded image, then fade in */
    };
    var pre = new Image();
    pre.onload = fadeThenSwap;
    pre.onerror = apply;
    pre.src = src;
    if (pre.complete) fadeThenSwap();
  }

  function productUrlOf(card) {
    var a = card && card.querySelector('a.full-unstyled-link');
    if (!a) return null;
    var href = (a.getAttribute('href') || '').split('?')[0];
    return href.indexOf('/products/') > -1 ? href : null;
  }

  function colorOptionIndex(p) {
    var opts = p.options || [];
    for (var i = 0; i < opts.length; i++) {
      var n = String(typeof opts[i] === 'string' ? opts[i] : opts[i].name || '').toLowerCase();
      if (n.indexOf('color') > -1 || n.indexOf('colour') > -1 || n.indexOf('色') > -1 || n.indexOf('カラー') > -1) return i;
    }
    return 0;
  }

  /* Build colour → featured image + same-colour 2nd image. */
  function build(p) {
    var ci = colorOptionIndex(p);
    var featured = {};   /* COLOR(upper) -> featured image FILENAME */
    var order = [];
    (p.variants || []).forEach(function (v) {
      var c = (v.options && v.options[ci]) || v['option' + (ci + 1)] || v.title;
      c = String(c).toUpperCase().trim();
      var ff = v.featured_image ? fname(v.featured_image.src) : null;
      if (order.indexOf(c) === -1) { order.push(c); featured[c] = ff; }
      else if (!featured[c] && ff) { featured[c] = ff; }
    });

    var imgs = (p.images || []).slice();
    var files = imgs.map(fname);
    var featuredIdx = {};               /* image index -> COLOR (start of a colour run) */
    order.forEach(function (c) {
      var idx = featured[c] ? files.indexOf(featured[c]) : -1;
      if (idx > -1) featuredIdx[idx] = c;
    });

    var second = {};                    /* COLOR -> full url of the same-colour 2nd image, or null */
    order.forEach(function (c) {
      var fIdx = featured[c] ? files.indexOf(featured[c]) : -1;
      var s = null;
      if (fIdx > -1) {
        var ni = fIdx + 1;
        if (ni < imgs.length && !(ni in featuredIdx)) s = imgs[ni]; /* next image, still same colour (stops at next colour's featured) */
      }
      second[c] = s;
    });

    /* single-colour product (e.g. the bag): no colour run to stop at,
       so the 2nd gallery image is simply the same product's 2nd shot. */
    if (order.length === 1 && !second[order[0]] && imgs.length > 1) {
      second[order[0]] = imgs[1];
    }

    return { featured: featured, second: second, order: order };
  }

  function getData(url, cb) {
    if (cache[url]) { cb(cache[url]); return; }
    fetch(url + '.js').then(function (r) { return r.json(); })
      .then(function (p) { var d = build(p); cache[url] = d; cb(d); })
      .catch(function () { cb(null); });
  }

  function activeColor(card) {
    if (card.dataset.bwColor) return card.dataset.bwColor;
    var a = card.querySelector('.bw-swatch.is-active') || card.querySelector('.bw-swatch');
    return a ? String(a.getAttribute('data-label')).toUpperCase().trim() : null;
  }

  /* ---- swatch: hover = preview, click = lock ---- */
  function applySwatch(swatch, persist) {
    var card = cardOf(swatch);
    var img = primaryImage(card);
    if (!img) return;
    if (!img.dataset.bwLockedSrc) img.dataset.bwLockedSrc = img.currentSrc || img.src;

    var target = swatch.getAttribute('data-variant-img');
    if (target) setImage(img, withWidth(target, 700));

    if (persist) {
      if (target) img.dataset.bwLockedSrc = withWidth(target, 700);
      card.dataset.bwColor = String(swatch.getAttribute('data-label')).toUpperCase().trim();
      var group = swatch.closest('[data-bw-swatches]');
      if (group) group.querySelectorAll('.bw-swatch').forEach(function (s) { s.classList.remove('is-active'); });
      swatch.classList.add('is-active');
      var url = swatch.getAttribute('data-variant-url');
      if (url) card.querySelectorAll('a.full-unstyled-link').forEach(function (a) { a.setAttribute('href', url); });
    }
  }
  function restoreLocked(card) {
    var img = primaryImage(card);
    if (img && img.dataset.bwLockedSrc) setImage(img, img.dataset.bwLockedSrc);
  }

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('.bw-swatch');
    if (sw) applySwatch(sw, false);
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('.bw-swatch');
    if (!sw) return;
    var to = e.relatedTarget;
    if (to && to.closest && to.closest('[data-bw-swatches]') === sw.closest('[data-bw-swatches]')) return;
    restoreLocked(cardOf(sw));
  });
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.bw-swatch');
    if (!sw) return;
    e.preventDefault(); e.stopPropagation();
    applySwatch(sw, true);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var sw = e.target.closest && e.target.closest('.bw-swatch');
    if (!sw) return;
    e.preventDefault();
    applySwatch(sw, true);
  });

  /* ---- card hover: 2nd image of the SAME colour ----
     Bound to .card-wrapper (NOT .card__media): Dawn lays the title
     link's ::after overlay (z-index:1) over the whole card incl. the
     photo, so mouseenter on .card__media never fires. The wrapper
     fires reliably because the overlay is its descendant. */
  function attachHover(root) {
    (root || document).querySelectorAll('.product-grid .card-wrapper, .collection .card-wrapper').forEach(function (card) {
      if (card.dataset.bwHover) return;
      card.dataset.bwHover = '1';
      var url = productUrlOf(card);
      if (!url) return;

      card.addEventListener('mouseenter', function () {
        var img = primaryImage(card);
        if (!img) return;
        if (!img.dataset.bwLockedSrc) img.dataset.bwLockedSrc = img.currentSrc || img.src;
        getData(url, function (d) {
          if (!d) return;
          var col = activeColor(card) || d.order[0];
          var sec = d.second[col];
          if (sec) setImage(img, withWidth(sec, 700));   /* else: stay — never jump colour */
        });
      });
      card.addEventListener('mouseleave', function () { restoreLocked(card); });
    });
  }

  /* ---- heading underline reveal ---- */
  function initHeadingReveal() {
    var heads = document.querySelectorAll('.bw-section-head');
    if (!heads.length) return;
    if (!('IntersectionObserver' in window)) { heads.forEach(function (h) { h.classList.add('bw-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('bw-in'); io.unobserve(e.target); } });
    }, { threshold: 0.3 });
    heads.forEach(function (h) { io.observe(h); });
  }

  function init() { attachHover(); initHeadingReveal(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) { attachHover(e.target); });
})();
